import * as React from 'react';
import * as styles from './styles.css';
import { Header2, InlineText1, InlineText2 } from '@cian/ui-kit/typography';
import { SubmitButton } from '../SubmitButton';

export interface IQuestionLayoutProps {
  title: string;
  description?: string;
  disableSubmit?: boolean;
  footer?: React.ReactElement;
  error?: string;
  buttonText?: string;
  showButtonPreloader?: boolean;
  buttonFullWidth?: boolean;

  onSubmit?(): void;
}

export const QuestionLayout: React.FC<IQuestionLayoutProps> = props => {
  const {
    description,
    children,
    title,
    onSubmit,
    disableSubmit,
    footer,
    buttonText = 'Дальше',
    showButtonPreloader,
    error,
    buttonFullWidth,
  } = props;

  const handleSubmit = React.useCallback<React.FormEventHandler>(
    e => {
      e.preventDefault();
      /* istanbul ignore else */
      if (onSubmit) {
        onSubmit();
      }
    },
    [onSubmit],
  );

  return (
    <form onSubmit={handleSubmit} className={styles['container']}>
      <div>
        <Header2>{title}</Header2>
      </div>
      {description && (
        <div className={styles['description']}>
          <InlineText1 color="black_60">{description}</InlineText1>
        </div>
      )}
      <div className={styles['answer']}>{children}</div>
      {onSubmit && (
        <SubmitButton disabled={disableSubmit} loading={showButtonPreloader} fullWidth={buttonFullWidth}>
          {buttonText}
        </SubmitButton>
      )}
      {error && (
        <div className={styles['error']} data-testid="error">
          <InlineText2 color="error_100">{error}</InlineText2>
        </div>
      )}
      {footer && (
        <div className={styles['footer']} data-testid="footer">
          {footer}
        </div>
      )}
    </form>
  );
};

QuestionLayout.displayName = 'QuestionLayout';
